import FAQ from "./FAQ";
import { entries } from "./landing-faq-data";

const faqs = entries.map(({ question, answer, renderAnswer }) => ({
  question,
  answer: renderAnswer ? renderAnswer() : answer,
}));

export default function LandingFAQ() {
  return <FAQ faqs={faqs} />;
}
